import React from 'react';

import FieldStartDate, { IFieldStartDate } from './gant/formField/fieldStartDate';

const outFieldStartDate: React.FC<IFieldStartDate> = ({ ...rest }) => {
    return <FieldStartDate {...rest} />;
};

export default outFieldStartDate;
